// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/bot_settings.proto (package tickettally.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/bot_settings.proto.
 */
export const file_v1_bot_settings: GenFile = /*@__PURE__*/
  fileDesc("ChV2MS9ib3Rfc2V0dGluZ3MucHJvdG8SDnRpY2tldHRhbGx5LnYxInUKC0JvdFNldHRpbmdzEhAKCHVzZXJuYW1lGAEgASgJEhQKDG1uX3N0b3BfdGltZRgCIAEoCRIUCgxtdF9zdG9wX3RpbWUYAyABKAkSFAoMbWJfc3RvcF90aW1lGAQgASgJEhIKCnN0YXJ0X3RpbWUYBSABKAkiFwoVR2V0Qm90U2V0dGluZ3NSZXF1ZXN0IkcKFkdldEJvdFNldHRpbmdzUmVzcG9uc2USLQoIc2V0dGluZ3MYASABKAsyGy50aWNrZXR0YWxseS52MS5Cb3RTZXR0aW5ncyJwChhVcGRhdGVCb3RTZXR0aW5nc1JlcXVlc3QSFAoMbW5fc3RvcF90aW1lGAEgASgJEhQKDG10X3N0b3BfdGltZRgCIAEoCRIUCgxtYl9zdG9wX3RpbWUYAyABKAkSEgoKc3RhcnRfdGltZRgEIAEoCSJsChlVcGRhdGVCb3RTZXR0aW5nc1Jlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSDwoHbWVzc2FnZRgCIAEoCRItCghzZXR0aW5ncxgDIAEoCzIbLnRpY2tldHRhbGx5LnYxLkJvdFNldHRpbmdzMt8BChJCb3RTZXR0aW5nc1NlcnZpY2USXwoOR2V0Qm90U2V0dGluZ3MSJS50aWNrZXR0YWxseS52MS5HZXRCb3RTZXR0aW5nc1JlcXVlc3QaJi50aWNrZXR0YWxseS52MS5HZXRCb3RTZXR0aW5nc1Jlc3BvbnNlEmgKEVVwZGF0ZUJvdFNldHRpbmdzEigudGlja2V0dGFsbHkudjEuVXBkYXRlQm90U2V0dGluZ3NSZXF1ZXN0GikudGlja2V0dGFsbHkudjEuVXBkYXRlQm90U2V0dGluZ3NSZXNwb25zZUIoWiZnaXRodWIuY29tL2R1Y2J0L3R0LWdvL2dlbi9wcm90by92MTt2MWIGcHJvdG8z");

/**
 * BotSettings represents user's bot time-based region settings
 *
 * @generated from message tickettally.v1.BotSettings
 */
export type BotSettings = Message<"tickettally.v1.BotSettings"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * HH:MM format, default: 16:24
   *
   * @generated from field: string mn_stop_time = 2;
   */
  mnStopTime: string;

  /**
   * HH:MM format, default: 17:24
   *
   * @generated from field: string mt_stop_time = 3;
   */
  mtStopTime: string;

  /**
   * HH:MM format, default: 18:24
   *
   * @generated from field: string mb_stop_time = 4;
   */
  mbStopTime: string;

  /**
   * HH:MM format, time the bot starts accepting messages, default: 06:00
   *
   * @generated from field: string start_time = 5;
   */
  startTime: string;
};

/**
 * Describes the message tickettally.v1.BotSettings.
 * Use `create(BotSettingsSchema)` to create a new message.
 */
export const BotSettingsSchema: GenMessage<BotSettings> = /*@__PURE__*/
  messageDesc(file_v1_bot_settings, 0);

/**
 * GetBotSettingsRequest
 *
 * @generated from message tickettally.v1.GetBotSettingsRequest
 */
export type GetBotSettingsRequest = Message<"tickettally.v1.GetBotSettingsRequest"> & {
};

/**
 * Describes the message tickettally.v1.GetBotSettingsRequest.
 * Use `create(GetBotSettingsRequestSchema)` to create a new message.
 */
export const GetBotSettingsRequestSchema: GenMessage<GetBotSettingsRequest> = /*@__PURE__*/
  messageDesc(file_v1_bot_settings, 1);

/**
 * GetBotSettingsResponse
 *
 * @generated from message tickettally.v1.GetBotSettingsResponse
 */
export type GetBotSettingsResponse = Message<"tickettally.v1.GetBotSettingsResponse"> & {
  /**
   * @generated from field: tickettally.v1.BotSettings settings = 1;
   */
  settings?: BotSettings;
};

/**
 * Describes the message tickettally.v1.GetBotSettingsResponse.
 * Use `create(GetBotSettingsResponseSchema)` to create a new message.
 */
export const GetBotSettingsResponseSchema: GenMessage<GetBotSettingsResponse> = /*@__PURE__*/
  messageDesc(file_v1_bot_settings, 2);

/**
 * UpdateBotSettingsRequest
 *
 * @generated from message tickettally.v1.UpdateBotSettingsRequest
 */
export type UpdateBotSettingsRequest = Message<"tickettally.v1.UpdateBotSettingsRequest"> & {
  /**
   * HH:MM format
   *
   * @generated from field: string mn_stop_time = 1;
   */
  mnStopTime: string;

  /**
   * HH:MM format
   *
   * @generated from field: string mt_stop_time = 2;
   */
  mtStopTime: string;

  /**
   * HH:MM format
   *
   * @generated from field: string mb_stop_time = 3;
   */
  mbStopTime: string;

  /**
   * HH:MM format, time the bot starts accepting messages
   *
   * @generated from field: string start_time = 4;
   */
  startTime: string;
};

/**
 * Describes the message tickettally.v1.UpdateBotSettingsRequest.
 * Use `create(UpdateBotSettingsRequestSchema)` to create a new message.
 */
export const UpdateBotSettingsRequestSchema: GenMessage<UpdateBotSettingsRequest> = /*@__PURE__*/
  messageDesc(file_v1_bot_settings, 3);

/**
 * UpdateBotSettingsResponse
 *
 * @generated from message tickettally.v1.UpdateBotSettingsResponse
 */
export type UpdateBotSettingsResponse = Message<"tickettally.v1.UpdateBotSettingsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: tickettally.v1.BotSettings settings = 3;
   */
  settings?: BotSettings;
};

/**
 * Describes the message tickettally.v1.UpdateBotSettingsResponse.
 * Use `create(UpdateBotSettingsResponseSchema)` to create a new message.
 */
export const UpdateBotSettingsResponseSchema: GenMessage<UpdateBotSettingsResponse> = /*@__PURE__*/
  messageDesc(file_v1_bot_settings, 4);

/**
 * BotSettingsService for managing time-based region detection
 *
 * @generated from service tickettally.v1.BotSettingsService
 */
export const BotSettingsService: GenService<{
  /**
   * @generated from rpc tickettally.v1.BotSettingsService.GetBotSettings
   */
  getBotSettings: {
    methodKind: "unary";
    input: typeof GetBotSettingsRequestSchema;
    output: typeof GetBotSettingsResponseSchema;
  },
  /**
   * @generated from rpc tickettally.v1.BotSettingsService.UpdateBotSettings
   */
  updateBotSettings: {
    methodKind: "unary";
    input: typeof UpdateBotSettingsRequestSchema;
    output: typeof UpdateBotSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_bot_settings, 0);

